import MenuItems from './menu-items.vue';

export default MenuItems;
